/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether the tool call only read data or could change state
 */
export const Impact = {
  ReadOnly: "read_only",
  Destructive: "destructive",
} as const;
/**
 * Whether the tool call only read data or could change state
 */
export type Impact = OpenEnum<typeof Impact>;

export type SummarizeToolCallResult = {
  /**
   * True when a stored summary was returned without calling the model
   */
  cached: boolean;
  /**
   * Whether the tool call only read data or could change state
   */
  impact: Impact;
  /**
   * A concise two-sentence description of the tool call and its effect
   */
  summary: string;
};

/** @internal */
export const Impact$inboundSchema: z.ZodMiniType<Impact, unknown> = openEnums
  .inboundSchema(Impact);

/** @internal */
export const SummarizeToolCallResult$inboundSchema: z.ZodMiniType<
  SummarizeToolCallResult,
  unknown
> = z.object({
  cached: z.boolean(),
  impact: Impact$inboundSchema,
  summary: z.string(),
});

export function summarizeToolCallResultFromJSON(
  jsonString: string,
): SafeParseResult<SummarizeToolCallResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SummarizeToolCallResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SummarizeToolCallResult' from JSON`,
  );
}
